<template>

    <div class="container">

        <app-head title="Admins" />

        <div class="d-flex justify-content-start align-items-center mb-3 gap-3">
            <h1 class="">{{ __('Administratoren') }}</h1>
            <div class="">
                <inertia-link class="btn btn-primary" :href="route('admin.admins.create')">
                    {{ __('Create') }}
                </inertia-link>
            </div>
        </div>

        <div class="d-flex mb-3">
            <search-filter v-model="form.search" class="" @reset="reset">
                <select-input label="Status" v-model="form.status">
                    <option :value="null">{{ __('Veröffentlicht') }}</option>
                    <option value="trashed">{{ __('Papierkorb') }}</option>
                </select-input>
            </search-filter>
        </div>

        <div class="d-flex justify-content-between">
            <results :meta="admins.meta" />
        </div>

        <div class="card">
            <data-table :items="admins.data"
                        :links="admins.meta.links"
                        :columns="columns"
                        >
                <data-table-row v-for="admin in admins.data" :key="admin.id">
                    <td>
                        {{ admin.id }}
                    </td>
                    <td>
                        <div v-if="admin.deleted_at">
                            {{ admin.name }}
                        </div>
                        <inertia-link class="" :href="route('admin.admins.edit', admin)" v-else>
                            {{ admin.name }}
                        </inertia-link>
                    </td>
                    <td>                           
                        <div class="small">
                            <i class="bi bi-envelope"></i>
                            <a :href="'mailto:' + admin.email">
                                {{ admin.email }}
                            </a>
                        </div>
                    </td>
                    <td>
                        <inertia-link :href="route('admin.users.index', {account_id: admin.id})">
                            {{ admin.users_count }}
                        </inertia-link>
                    </td>
                    <td class="text-end py-0">

                        <template v-if="admin.deleted_at">
                            <button type="button" class="btn btn-outline-success" @click="restore(admin)">
                                {{ __('Restore') }}
                            </button>
                            <button type="button" class="btn btn-outline-danger" @click="destroyPermanently(admin)">
                                {{ __('Destroy permanently') }}
                            </button>
                        </template>
                        <div class="dropdown" v-else>
                            <button class="btn btn-outline-secondary" 
                                    type="button" 
                                    :id="`dropdownMenuAdmin-${admin.id}`" 
                                    :title="__('Edit')"
                                    data-bs-toggle="dropdown" 
                                    aria-expanded="false">
                                <i class="bi bi-three-dots-vertical"></i>
                                {{ __('Edit') }}
                            </button>
                            <div class="dropdown-menu dropdown-menu-end" :aria-labelledby="`dropdownMenuAdmin-${admin.id}`">
                                <inertia-link :href="route('admin.admins.edit', {admin})" class="dropdown-item">
                                    {{ __('Bearbeiten') }}
                                </inertia-link>
                                <inertia-link :href="route('admin.users.index', {account_id: admin.id})" class="dropdown-item">
                                    {{ __('Users') }}
                                </inertia-link>
                            </div>
                        </div>
                    </td>
                </data-table-row>
            </data-table>
        </div>

    </div>

</template>

<script>

    import DataTable from '@/shared/Admin/DataTable';
    import DataTableRow from '@/shared/Admin/DataTableRow';
    import SearchFilter from '@/shared/Admin/SearchFilter';
    import SelectInput from '@/shared/Inputs/SelectInput';

    import Results from '@/shared/Admin/Results';

    export default {
        props: [
            'filters',
            'admins',
        ],
        components: {
            SearchFilter,
            SelectInput,
            DataTable,
            DataTableRow,
            Results,
        },
        data() {
            return {
                form: {
                    search: this.filters.search,
                    status: this.filters.status,
                },
                columns: {
                    id: {label: 'ID', sortable: 'id'},
                    name: {label: 'Name', sortable: 'name'},
                    email: {label: 'E-Mail', sortable: 'email'},
                    users_count: {label: 'User', sortable: 'users_count'},
                },
            }
        },
        watch: {
            form: {
                deep: true,
                handler: _.debounce(function () {
                    this.$inertia.get(this.route('admin.admins.index'), this.form, {preserveState: true})
                }, 300, {trailing: true}),
            },
        },
        methods: {
            reset() {
                this.form = _.mapValues(this.form, () => null)
            },
            destroyPermanently(admin) {
                if (confirm(this.__('Sind Sie sicher?'))) {
                    this.$inertia.delete(this.route('admin.admins.destroy-permanently', admin.id));
                }
            },
            restore(admin) {
                this.$inertia.get(this.route('admin.admins.restore', admin.id));
            },
        },
    }
</script>